// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Bills_upper__metrics__Gedgp {
  width: 100%;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  margin-bottom: 5rem;
}
@media only screen and (max-width: 62.5em) {
  .Bills_upper__metrics__Gedgp {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media only screen and (max-width: 56.25em) {
  .Bills_upper__metrics__Gedgp {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media only screen and (max-width: 37.5em) {
  .Bills_upper__metrics__Gedgp {
    grid-template-columns: repeat(2, 1fr);
  }
}
.Bills_upper__metrics_cable__a1vCE {
  height: 10rem;
  background-color: #C1DAFF;
  border-radius: 5px;
  font-style: normal;
  font-weight: 700;
  font-size: 1.8rem;
  line-height: 2.2rem;
  border-radius: 5px;
}
.Bills_upper__metrics_airtime__i8AiO {
  height: 10rem;
  background-color: #569755;
  font-style: normal;
  font-weight: 700;
  font-size: 1.8rem;
  line-height: 2.2rem;
  color: #FFFFFF;
  border-radius: 5px;
}
.Bills_upper__metrics_data__QgccS {
  height: 10rem;
  background-color: #F7D1CD;
  border-radius: 5px;
  font-style: normal;
  font-weight: 700;
  font-size: 1.8rem;
  line-height: 2.2rem;
  border-radius: 5px;
}
.Bills_upper__metrics_electricity__AtFEt {
  height: 10rem;
  background-color: var(--color-error);
  color: var(--color-white);
  border-radius: 5px;
  font-style: normal;
  font-weight: 700;
  font-size: 1.8rem;
  line-height: 2.2rem;
  border-radius: 5px;
}
.Bills_upper__searchFilter__4uGz- {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 5.6rem;
}
.Bills_upper__searchFilter_filetr__UHzp- {
  width: 40rem;
}

.Bills_status__oO6Jk {
  display: flex;
  align-items: center;
  align-content: center;
  margin-top: 1rem;
}
.Bills_status__pending__yzXvV {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  color: #7E6E1F;
  position: absolute;
  height: 3rem;
  width: 10rem;
  background-color: #FFF5D7;
  border: 0.5px solid #7E6E1F;
  border-radius: 5px;
}
.Bills_status__done__uYsOo {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  color: #569755;
  position: absolute;
  height: 3rem;
  width: 10rem;
  background-color: #E4FFEC;
  border: 0.5px solid #569755;
  border-radius: 5px;
}
.Bills_status__failed__1omOu {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  color: #E12F2F;
  position: absolute;
  height: 3rem;
  width: 10rem;
  background-color: #FFE8E8;
  border: 0.5px solid #E12F2F;
  border-radius: 5px;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Bills/Bills.module.scss"],"names":[],"mappings":"AAGC;EACC,WAAA;EACA,sBAAA;EACA,aAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;AAFF;AAIE;EARD;IASE,qCAAA;EADD;AACF;AAGE;EAZD;IAaE,qCAAA;EAAD;AACF;AAEE;EAhBD;IAiBE,qCAAA;EACD;AACF;AACE;EACC,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AACH;AAGE;EACC,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AADH;AAIE;EACC,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AAFH;AAKE;EACC,aAAA;EACA,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AAHH;AAQC;EACC,aAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;AANF;AAQE;EACC,YAAA;AANH;;AAWA;EACC,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;AARD;AAUC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,2BAAA;EACA,kBAAA;AARF;AAWC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,2BAAA;EACA,kBAAA;AATF;AAYC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,2BAAA;EACA,kBAAA;AAVF","sourcesContent":["@import '../variables/breakpoints';\n\n.upper {\n\t&__metrics {\n\t\twidth: 100%;\n\t\tbox-sizing: border-box;\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(4, 1fr);\n\t\tgap: 1rem;\n\t\tmargin-bottom: 5rem;\n\n\t\t@media only screen and (max-width: $bp-1000) {\n\t\t\tgrid-template-columns: repeat(3, 1fr);\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-900) {\n\t\t\tgrid-template-columns: repeat(3, 1fr);\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\tgrid-template-columns: repeat(2, 1fr);\n\t\t}\n\n\t\t&_cable {\n\t\t\theight: 10rem;\n\t\t\tbackground-color: #C1DAFF;\n\t\t\tborder-radius: 5px;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 700;\n\t\t\tfont-size: 1.8rem;\n\t\t\tline-height: 2.2rem;\n\t\t\tborder-radius: 5px;\n\n\t\t}\n\n\t\t&_airtime {\n\t\t\theight: 10rem;\n\t\t\tbackground-color: #569755;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 700;\n\t\t\tfont-size: 1.8rem;\n\t\t\tline-height: 2.2rem;\n\t\t\tcolor: #FFFFFF;\n\t\t\tborder-radius: 5px;\n\t\t}\n\n\t\t&_data {\n\t\t\theight: 10rem;\n\t\t\tbackground-color: #F7D1CD;\n\t\t\tborder-radius: 5px;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 700;\n\t\t\tfont-size: 1.8rem;\n\t\t\tline-height: 2.2rem;\n\t\t\tborder-radius: 5px;\n\t\t}\n\n\t\t&_electricity {\n\t\t\theight: 10rem;\n\t\t\tbackground-color: var(--color-error);\n\t\t\tcolor: var(--color-white);\n\t\t\tborder-radius: 5px;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 700;\n\t\t\tfont-size: 1.8rem;\n\t\t\tline-height: 2.2rem;\n\t\t\tborder-radius: 5px;\n\t\t}\n\n\t}\n\n\t&__searchFilter {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\twidth: 100%;\n\t\tmargin-top: 5.6rem;\n\n\t\t&_filetr {\n\t\t\twidth: 40rem;\n\t\t}\n\t}\n}\n\n.status {\n\tdisplay: flex;\n\talign-items: center;\n\talign-content: center;\n\tmargin-top: 1rem;\n\n\t&__pending {\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tpadding: 1rem;\n\t\tcolor: #7E6E1F;\n\t\tposition: absolute;\n\t\theight: 3rem;\n\t\twidth: 10rem;\n\t\tbackground-color: #FFF5D7;\n\t\tborder: 0.5px solid #7E6E1F;\n\t\tborder-radius: 5px;\n\t}\n\n\t&__done {\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tpadding: 1rem;\n\t\tcolor: #569755;\n\t\tposition: absolute;\n\t\theight: 3rem;\n\t\twidth: 10rem;\n\t\tbackground-color: #E4FFEC;\n\t\tborder: 0.5px solid #569755;\n\t\tborder-radius: 5px;\n\t}\n\n\t&__failed {\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tpadding: 1rem;\n\t\tcolor: #E12F2F;\n\t\tposition: absolute;\n\t\theight: 3rem;\n\t\twidth: 10rem;\n\t\tbackground-color: #FFE8E8;\n\t\tborder: 0.5px solid #E12F2F;\n\t\tborder-radius: 5px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"upper__metrics": `Bills_upper__metrics__Gedgp`,
	"upper__metrics_cable": `Bills_upper__metrics_cable__a1vCE`,
	"upper__metrics_airtime": `Bills_upper__metrics_airtime__i8AiO`,
	"upper__metrics_data": `Bills_upper__metrics_data__QgccS`,
	"upper__metrics_electricity": `Bills_upper__metrics_electricity__AtFEt`,
	"upper__searchFilter": `Bills_upper__searchFilter__4uGz-`,
	"upper__searchFilter_filetr": `Bills_upper__searchFilter_filetr__UHzp-`,
	"status": `Bills_status__oO6Jk`,
	"status__pending": `Bills_status__pending__yzXvV`,
	"status__done": `Bills_status__done__uYsOo`,
	"status__failed": `Bills_status__failed__1omOu`
};
export default ___CSS_LOADER_EXPORT___;
